import { ValueGetterParams } from "ag-grid-community";
import { createWorkflowApi } from "../../api-helpers/CommonUtilsApiHelper";
import { WorkflowState } from "common-util-experience-client";

const workflowApi = createWorkflowApi();

export const workflowStatesCache = new Map<string, string>();

const pendingStateRequests = new Map<string, Promise<void>>();

const workFlowTypes = [
    "Problem",
    "Appointment",
    "Intervention",
    "Goal",
    "Task",
    "Pathway",
    "CarePlan",
    "Eligibility"
];

async function loadStates(workflowId: string): Promise<void> {
    try {
        const statesResponse = await workflowApi.workflowControllerGetStatesForWorkflow(workflowId);
        
        // Check if statesResponse.data is an array
        if (Array.isArray(statesResponse.data)) {
            statesResponse.data.forEach((state: WorkflowState) => {
                workflowStatesCache.set(state.stateId, state.stateName);
            });
        }
    } catch (error) {
        console.error(error);
    }
}

export function cacheAllWorkflowStates(): void {
    workFlowTypes.forEach((workFlowType) => {
        loadStates(workFlowType);
    });
}

export const WorkflowStateCellValueGetter = (workflowId: string, params: ValueGetterParams) => {
    if (!workflowId) {
        return "-";
    }

    const lookupId = params.data[params.colDef.field!];
    if (!lookupId) {
        return "-";
    }
    if (workflowStatesCache.has(lookupId)) {
        return workflowStatesCache.get(lookupId);
    }

    if (!pendingStateRequests.has(lookupId)) {
        const request = workflowApi
            .workflowControllerGetWorkFlowState(workflowId, lookupId)
            .then((response) => {
                workflowStatesCache.set(lookupId, response.data.stateName);
            })
            .catch((error) => {
                console.error(error);
            })
            .finally(() => {
                pendingStateRequests.delete(lookupId);
            });
        pendingStateRequests.set(lookupId, request);
    }

    pendingStateRequests.get(lookupId)!.then(() => {
        params.api.refreshCells({
            rowNodes: [params.node!],
            columns: [params.column],
        });
    });

    return "-";
};
